import General from '../assets/img/parking_icons/general.png'
import BusStop from '../assets/img/parking_icons/bus_stop.png'
import MeterNotInEffect from '../assets/img/parking_icons/meter_not_in_effect.png'
import MeterParking from '../assets/img/parking_icons/meter_parking.png'
import NoParking from '../assets/img/parking_icons/no_parking.png'
import NoStanding from '../assets/img/parking_icons/no_standing.png'
import NoStopping from '../assets/img/parking_icons/no_stopping.png'
import StreetCleaning from '../assets/img/parking_icons/street_cleaning.png'
import AuthorizedParking from '../assets/img/parking_icons/authorized_parking.png'
import TruckSymbol from '../assets/img/parking_icons/truck_symbol.png'
import TaxiSymbol from '../assets/img/parking_icons/taxi_symbol.png'
import TaxiHailSymbol from '../assets/img/parking_icons/taxi_hail_symbol.png'

const otherCategories = sign_description => {
  if (sign_description.toLowerCase().indexOf('truck') > -1) {
    return TruckSymbol
  } else if (sign_description.toLowerCase().indexOf('taxi hailing') > -1) {
    return TaxiHailSymbol
  } else if (sign_description.toLowerCase().indexOf('taxi') > -1) {
    return TaxiSymbol
  } else {
    return General
  }
}

export const parkingIconsForMap = sign => {
  switch (sign.properties.smo_subtype) {
    case 'Bus Stop':
      return BusStop
    case 'Metered Parking':
      return MeterParking
    case 'Meters Not in Effect':
      return MeterNotInEffect
    case 'No Parking (Non-ASP)':
      return NoParking
    case 'No Standing':
      return NoStanding
    case 'No Stopping':
      return NoStopping
    case 'Street Cleaning':
      return StreetCleaning
    case 'Authorized Parking':
      return AuthorizedParking
    default:
      return otherCategories(sign.properties.sign_description)
  }
}

export const parkingIcons = subcategory => {
  switch (subcategory) {
    case 'Bus Stop':
      return BusStop
    case 'Metered Parking':
      return MeterParking
    case 'Meters Not in Effect':
      return MeterNotInEffect
    case 'No Parking (Non-ASP)':
      return NoParking
    case 'No Standing':
      return NoStanding
    case 'No Stopping':
      return NoStopping
    case 'Street Cleaning':
      return StreetCleaning
    case 'Authorized Parking':
      return AuthorizedParking
    default:
      return General
  }
}



// WEBPACK FOOTER //
// ./src/utils/ParkingIcons.js